import { useNavigate, useLocation } from "react-router-dom"

export function useUpdateSearchParams(transform: (params: URLSearchParams) => URLSearchParams) {
    const navigate = useNavigate()
    const location = useLocation()

    return function () {
        const newParams = transform(new URLSearchParams(location.search)).toString()
        let path = location.pathname

        if (newParams.length > 0) {
            path += `?${newParams}`
        }

        navigate(path, { replace: true })
    }
}
